import { useState, useRef, useImperativeHandle, forwardRef } from 'react';
import styled from 'styled-components';

import { ReactComponent as LeftArrowSvg } from '../../image/LeftArrow.svg';

const HoldingSettingCountInput = forwardRef((props, ref) => {
  const { text } = props;

  const [dateVal, setDateVal] = useState(0);

  const InputRef = useRef();

  useImperativeHandle(ref, () => ({
    setValue: (val) => {
      setDateVal(val);
    },
    getValue: () => {
      return dateVal;
    }
  }))

  // 입력값 변경시 //
  function onChangeInput(e) {
    const regex = /[^0-9]/g;
    const result = e.target.value.replace(regex, "");
    setDateVal(result === '' ? 0 : parseInt(result));
  }

  // 증가 버튼 클릭시 //
  function onClickUp() {
    setDateVal(dateVal + 1);
  }

  // 감소 버튼 클릭시 //
  function onClickDown() {
    if (dateVal > 0) setDateVal(dateVal - 1);
  }

  return (
    <TopLevelWrapper>
      <Input
        ref={InputRef}
        placeholder={0}
        value={dateVal}
        onChange={onChangeInput} />
      <ButtonWrapper>
        <Button onClick={onClickUp}><StyledArrow isUp={true} /></Button>
        <Button onClick={onClickDown}><StyledArrow isUp={false} /></Button>
      </ButtonWrapper>
      <Text
        fontFamily='NotoSansKR-Regular'
        fontSize={12}>
        {text}
      </Text>
    </TopLevelWrapper>
  )
})

export default HoldingSettingCountInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 8px;

  transition: all 0.3s ease-in-out;
`;

const Input = styled.input`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 69px;
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  padding: 0 0 0 8px;
  margin: 0 5px 0 0;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  ::placeholder {
    color: ${props => props.theme.line};
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
  margin-right: 8px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 30px;
  height: 30px;

  border: 1px solid ${props => props.theme.buttonFill};
  border-radius: 8px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const StyledArrow = styled(LeftArrowSvg)`
  width: 9.6px;
  height: 17.7px;

  transform: ${props => props.isUp ? 'rotate(90deg)' : 'rotate(-90deg)'};

  & path {
    fill: ${props => props.theme.subText};
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;
